<template>
  <div class="css-tr">
    <div class="css-th align right w-f7">公司抬頭</div>
    <div class="css-td">
      <input
        v-model="companyTitle"
        class="input-lg"
        minlength="3"
        maxlength="50"
        autocomplete="off"
        name="order_invoice_title"
        v-validate="'required'"
        type="text" />
      <p v-if="errors.has('order_invoice_title')" class="error">* {{ errors.first('order_invoice_title') }}</p>
    </div>
  </div>
</template>

<script>
import { createAdvComputed } from '@/helpers/vuex';
import { index } from '@/components/desktop/step1/invoice-method/paper-invoice/child/constant/company-title.constant';

export default {
  name: 'company-title',
  inject: ['$validator'],
  props: [
    /** 與 Vuex 綁定的 module 名稱 */
    'module',
    /** 與 Vuex 綁定的 state 名稱 */
    'states',
  ],
  computed: {
    /** [公司抬頭] state */
    companyTitle: createAdvComputed(index.companyTitle),
  },
};
</script>
